import type { EquipmentSlot, InventoryEntry } from "@idle-rpg/shared";

export type PresetSlot = {
  slot: EquipmentSlot;
  itemId: string | null;
  itemInstanceId: string | null;
};

export type PresetDiffChange = {
  slot: EquipmentSlot;
  action: "equip" | "unequip";
  currentItemId?: string | null;
  targetItemId?: string | null;
  targetItemInstanceId?: string | null;
};

export type PresetDiff = {
  outOfSync: boolean;
  changes: PresetDiffChange[];
};

export function computePresetDiff(_: {
  equipment: Record<EquipmentSlot, InventoryEntry | null>;
  presetSlots: PresetSlot[];
}): PresetDiff {
  const { equipment, presetSlots } = _;
  const changes: PresetDiffChange[] = [];

  for (const presetSlot of presetSlots) {
    const current = equipment[presetSlot.slot];
    const currentItemId = current?.itemId ?? null;
    const currentInstanceIds = current?.instanceIds ?? [];

    if (!presetSlot.itemId) {
      if (currentItemId) {
        changes.push({
          slot: presetSlot.slot,
          action: "unequip",
          currentItemId
        });
      }
      continue;
    }

    const matchesItem =
      currentItemId === presetSlot.itemId &&
      (!presetSlot.itemInstanceId || currentInstanceIds.includes(presetSlot.itemInstanceId));
    if (matchesItem) continue;

    changes.push({
      slot: presetSlot.slot,
      action: "equip",
      targetItemId: presetSlot.itemId,
      targetItemInstanceId: presetSlot.itemInstanceId ?? null
    });
  }

  return {
    outOfSync: changes.length > 0,
    changes
  };
}
